export default {
    modal: {
        confirmOrder: {
            title: "Order confirmation",
            orderNumber: "Order number",
            orderDate: "Order date",
            totalSum: "Total sum",
            quantity: "Quantity",
            status: "Status",
            store: "Store",
            button: {
                confirm: "Confirm",
                close: "Close"
            }
        },
        cancelOrder: {
            title: "Cancel the order",
            cancelWarningMessage: "Are you sure you want to cancel this order? Once canceled, the order cannot be renewed.",
            orderNumber: "Order number",
            orderDate: "Order date",
            totalSum: "Total sum",
            quantity: "Quantity",
            status: "Status",
            store: "Store",
            button: {
                cancel: "Cancel",
                close: "Close"
            }
        },
        rateProduct: {
            title: "Rate the product",
            orderDate: "Order date",
            totalSum: "Total sum",
            quantity: "Quantity",
            subtitle: {
                rateProduct: "Rate the product",
                leaveComment: "Leave a comment"
            },
            optional: "optional",
            button: {
                close: "Close",
                rate: "Rate"
            }
        }
    }
};

